import { render } from "./TheHeader.vue?vue&type=template&id=557ed71c&scoped=true"
import script from "./TheHeader.vue?vue&type=script&scoped=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&scoped=true&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=557ed71c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557ed71c"]])

export default __exports__